//@ts-nocheck
import { useState } from "react";
import { BookingType, IUseSearchViewModel } from "./types";

function calculateGateWay(baseValue: number) {
  let baseRate = 1.5 / 100;
  let additionalCharge = 100;
  // if (countryOfUser !== "Nigeria") {
  //   baseRate = 3.9 / 100;
  // }
  if (baseValue < 2500) {
    additionalCharge = 0;
  }
  let result = baseValue * baseRate + additionalCharge;
  if (result >= 2000) {
    result = 2000;
  }
  return Math.round(result);
}
export const useBookingStore = (
  bookingData: BookingType,
  adapter: IUseSearchViewModel["adapter"]
) => {
  const [data, setData] = useState<BookingType>(bookingData);
  const [loading, setLoading] = useState(false);

  const onPayWithWallet = async () => {
    setLoading(true);
    try {
      await adapter.onPayWithWallet();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  function buildPaymentInfo(paymentData?: {
    slug: string;
    walletBalance: number;
    tutors: any[];
    tuitionFee: number;
    totalLessons: number;
    totalDiscount: number;
    couponDiscount: number;
  }) {
    return {
      ...(paymentData || {}),
      distanceThreshold: data.distanceThreshold,
      farePerKm: data.farePerKm,
      currency: data.currency,
      monthsPaid: data.monthsPaid,
      discountRemoved: data.discountRemoved,
      gatewayFee: data.gatewayFee,
      timeSubmitted: data.timeSubmitted,
      discountCode: data.discountCode,
      actualAmountPaid: data.actualAmountPaid,
    };
  }
  async function generateSpeakingInvoice(amount: number) {
    return await adapter.generateSpeakingInvoice(
      amount + calculateGateWay(amount),
      buildPaymentInfo(),
      "speaking"
    );
  }
  async function generateInvoice(amount: number, paymentMethod: string) {
    const fee = paymentMethod === "stripe" ? 0 : calculateGateWay(amount);
    setData({
      ...data,
      gatewayFee: fee,
      actualAmountPaid: amount,
    });
    return await adapter.generateInvoice(
      paymentMethod === "stripe" ? amount : Math.round(amount + fee),
      buildPaymentInfo()
    );
  }
  return {
    onPayWithWallet,
    generateInvoice,
    generateSpeakingInvoice,
    calculateGateWay,
    amountToBePaid: null,
    onBeginCheckout: adapter?.onBeginCheckout,
    bookingDetails: {
      bookingId: data.slug,
      userInfo: {
        firstName: "",
        title: "",
        walletBalance: 0,
      },
      lessonInfo: {
        numberOfLessons: 0,
        lessonAmount: 0,
        selectedTutors: [],
      },
    },
    buildPaymentInfo,
    monthsPaid: data.monthsPaid,
    multipleMonthDiscount({
      value,
      discountRemoved,
    }: {
      value: number;
      discountRemoved: number;
    }) {
      setData({
        ...data,
        monthsPaid: value,
        discountRemoved: discountRemoved,
      });
    },
    speakingFee: data.speakingFee || 0,
    currency: data.currency || "NGN",
    paidSpeakingFee: data.paidSpeakingFee,
  };
};
